import { NextApiHandler } from 'next'
import { GenericServerError, handleApiRouteError } from '../errors'

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'

type NextApiHandlerMap = Partial<Record<Method, NextApiHandler>>

type MethodHandler = (apiRouteMap: NextApiHandlerMap) => NextApiHandler

export const handleMethods: MethodHandler = (handlers) => async (req, res) => {
  const { method } = req
  const handler = method && handlers[method as Method]
  if (handler) {
    handler(req, res)
  } else {
    const error = new GenericServerError({
      httpStatus: 405,
      message: `Method: ${method} not allowed`,
    })
    handleApiRouteError(error, req, res)
  }
}

export const handleMethod =
  (method: Method, handler: NextApiHandler): NextApiHandler =>
  async (req, res) => {
    if (req.method === method) {
      handler(req, res)
    } else {
      const error = new GenericServerError({
        httpStatus: 405,
        message: `Method: ${method} not allowed`,
      })
      handleApiRouteError(error, req, res)
    }
  }
